import { CouponDetailViewModel, CouponListItemViewModel } from "@payping/api";
import { CLEAR_LIST, LOGGED_OUT } from "./constants";
import { ClearListAction, LoggedOutAction } from "./types";

export const COUPONS_LOADED = "COUPONS_LOADED";
export const SET_COUPON_DETAILS = "SET_COUPON_DETAILS";
export const COUPON_REMOVED = "COUPON_REMOVED";
export const TOGGLE_COUPON_ACTIVATION = "TOGGLE_COUPON_ACTIVATION";
export const TOGGLE_COUPON_ARCHIVE = "TOGGLE_COUPON_ARCHIVE";

export interface CouponState {
  list: CouponListItemViewModel[];
  totalCount: number;
  paginationEnd: boolean;
  details?: CouponDetailViewModel;
}

export interface CouponsLoadedAction {
  type: typeof COUPONS_LOADED;
  payload: { list: CouponListItemViewModel[]; totalCount: number; append: boolean };
}

export interface SetCouponDetailsAction {
  type: typeof SET_COUPON_DETAILS;
  payload: { details: CouponDetailViewModel };
}

export interface CouponRemovedAction {
  type: typeof COUPON_REMOVED;
  payload: { code: string };
}

export interface ToggleCouponActivationAction {
  type: typeof TOGGLE_COUPON_ACTIVATION;
  payload: { code: string };
}

export interface ToggleCouponArchiveAction {
  type: typeof TOGGLE_COUPON_ARCHIVE;
  payload: { code: string };
}

export type CouponActionTypes =
  | CouponsLoadedAction
  | SetCouponDetailsAction
  | CouponRemovedAction
  | ToggleCouponActivationAction
  | ToggleCouponArchiveAction
  | ClearListAction
  | LoggedOutAction;

const initialState: CouponState = {
  details: undefined,
  list: [],
  paginationEnd: false,
  totalCount: 0,
};

export default function coupons(state = initialState, action: CouponActionTypes): CouponState {
  if (action.type === COUPONS_LOADED) {
    const { list, totalCount, append } = action.payload;
    const newList = append ? [...state.list, ...list] : list;
    return {
      ...state,
      list: newList,
      paginationEnd: !list.length || newList.length >= totalCount,
      totalCount,
    };
  }

  if (action.type === SET_COUPON_DETAILS) {
    const { details } = action.payload;
    return {
      ...state,
      details,
    };
  }

  if (action.type === COUPON_REMOVED) {
    const { code } = action.payload;
    const list = state.list.filter((item) => item.code !== code);
    const details = state.details && state.details.code === code ? initialState.details : state.details;

    return {
      ...state,
      details,
      list,
    };
  }

  if (action.type === TOGGLE_COUPON_ACTIVATION) {
    const { code } = action.payload;
    const list = state.list.map((item) => {
      if (item.code === code) {
        return {
          ...item,
          ...(typeof item.isActive === "boolean" ? { isActive: !item.isActive } : {}),
        };
      }
      return item;
    });
    const details =
      state.details && state.details.code === code
        ? { ...state.details, isActive: !state.details.isActive }
        : state.details;

    return {
      ...state,
      details,
      list,
    };
  }

  if (action.type === TOGGLE_COUPON_ARCHIVE) {
    const { code } = action.payload;
    const itemInList = state.list.find((item) => item.code === code);
    let { list } = state;
    let { details } = state;
    if (itemInList) {
      list = list.filter((item) => item.code !== code);
    } else if (state.details && state.details.code === code) {
      details = { ...state.details, isArchived: !state.details.isArchived };
      list = [details, ...list];
    }

    return {
      ...state,
      details,
      list,
    };
  }

  if (action.type === CLEAR_LIST) {
    return {
      ...state,
      list: [],
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }

  return state;
}
